import { Uri } from '@nextforce/api'
import { useCallback, useState } from 'react'
import { View } from 'react-native'
import { Menu } from 'react-native-popup-menu'
import { useShift } from 'shifts/queries/detail'
import { useUser } from 'users/queries/detail'
import { RatingMenu } from '../menu'
import { useAddShiftRating } from '../queries/add'
import { RatingView } from './view'

const DEFAULT_RATING = 3

interface RatingScreenProps {
  menuRef: React.MutableRefObject<Menu | null | undefined>
  onCloseRatingMenu(): void
  rateCrew?: boolean
  rateStore?: boolean
  uri: Uri
}

export function RatingScreen({
  menuRef,
  onCloseRatingMenu,
  rateCrew,
  rateStore,
  uri,
}: RatingScreenProps) {
  const shiftRatingMutation = useAddShiftRating(rateCrew)
  const shiftQuery = useShift({ uri: uri })
  const { data: user } = useUser()
  const shiftData = shiftQuery.data
  const [rating, setRating] = useState<number>(DEFAULT_RATING)
  const [error, setError] = useState<any>(undefined)

  const onPressCloseButton = useCallback(async () => {
    await menuRef.current?.close()
  }, [menuRef])

  const onSubmit = useCallback(async () => {
    if (shiftData?.shift?.id && user?.id) {
      try {
        await shiftRatingMutation.mutateAsync({
          shiftId: shiftData?.shift?.id,
          raterId: user?.id,
          rating: rating,
        })
        await menuRef.current?.close()
      } catch (err: any) {
        setError(err)
      }
    }
  }, [menuRef, rating, shiftData?.shift?.id, shiftRatingMutation, user?.id])

  return (
    <View>
      <RatingMenu menuRef={menuRef} onCloseRatingMenu={onCloseRatingMenu}>
        <RatingView
          shift={shiftData?.shift}
          rateCrew={rateCrew}
          rateStore={rateStore}
          error={error}
          onSubmit={onSubmit}
          onPressCloseButton={onPressCloseButton}
          onChangeRating={setRating}
        />
      </RatingMenu>
    </View>
  )
}
